let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aBWzi")).then(() => parcelRequire('5tfmm'));